<template>
  <div class="vacation-services">
    <div class="vacation-services-list">
      <div v-for="(service, i) in services" :key="i" class="vacation-service">
        <template
          v-if="
            ['gudauri', 'bansko'].includes(vacation.site.name.toLowerCase()) &&
            service.title === 'השכרת ציוד'
          "
        ></template>
        <div v-else>
          <i
            v-if="service.info"
            class="icon icon-info info"
            :title="service.title"
            :data-info="service.info"
          ></i>
          <h3>{{ service.title }}</h3>
          <p v-html="service.content"></p>
        </div>
      </div>
    </div>

    <div v-if="actions" class="vacation-actions">
      <div class="vacation-action">
        <a href="https://pay.skideal.co.il/Home/LoginPopup">
          <button class="icon-button">
            <i class="icon icon-plus"></i>
          </button>
          <div class="vacation-action-label">
            <div>
              {{ $t("להוספת שרותי סקי לחבילה") }} (#{{ vacation.number }})
            </div>
            <span style="display: block">
              {{
                $t(
                  "לחצו כאן במידה ומעוניינים להוסיף שרותי סקי נוספים לחבילה. המחירים נמוכים בעד 40% מאשר באתר הסקי עצמו."
                )
              }}
            </span>
          </div>
        </a>
      </div>
      <div class="vacation-action">
        <a href="https://www.ophirbit.co.il/aff/?aid=683">
          <button class="icon-button">
            <i class="icon icon-plus"></i>
          </button>
          <div class="vacation-action-label">
            <div>{{ $t("הוספת ביטוח נסיעות כולל ספורט חורף") }}</div>
            <span style="display: block">
              {{
                $t(
                  "לצפיה בפרטי הפוליסה ורכישה במחיר בלעדי של ביטוח הנסיעות כולל ספורט חורף הראל First Class"
                )
              }}
            </span>
          </div>
        </a>
      </div>
      <div :class="{ 'vacation-action': true, active: extraInfoExpanded }">
        <a href="#" @click.prevent="extraInfoExpanded = !extraInfoExpanded">
          <span>{{
            $t(
              "למידע נוסף על אתר הסקי, קבלת הטבות, יצירת קשר עם נציגנו באתר ועוד המון מידע ושירותים- הורידו את אפליקציית  SKIDEAL"
            )
          }}</span>
          <i class="icon icon-next"></i>
        </a>
        <div v-if="extraInfoExpanded" class="vacation-action-content">
          <a
            v-for="(button, i) in siteData.mobile_app_buttons"
            :key="i"
            :href="button['link']['url']"
            target="_blank"
          >
            <img :src="button['image_url']" />
          </a>
        </div>
      </div>
      <div style="display: none" class="vacation-action">
        <a :href="'mailto:' + siteData.contact_email">
          <span>{{ $t("ליצירת קשר במייל עם נציגנו באתר הסקי") }}</span>
          <i class="icon icon-next"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    actions: {
      type: Boolean,
      default: false,
    },
    services: {
      type: Array,
      default: [],
    },
    vacation: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      siteData: window.siteData,
      extraInfoExpanded: false,
    };
  },
};
</script>
